import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureFlagStore } from '../stores/feature-flag.store';

/**
 * Blocks a route unless the given feature flag is enabled for the complex (globally active AND
 * enabled for this complex — the backend enforces both). Ensures the flags are loaded first so a
 * direct URL / bookmark is handled correctly, not just in-app nav. Denied access redirects to the
 * dashboard home rather than showing a locked shell.
 *
 * Use only for pure super-admin flags with no self-serve path (e.g. Campaigns). Pro-upsell
 * features (Tournaments, Price Rules) stay reachable so the user can upgrade.
 */
/**
 * Passes when ANY of the given flags is on. A single code is the normal case; the list form is for
 * a screen that more than one flag should unlock.
 */
export function featureFlagGuard(codes: string | readonly string[]): CanActivateFn {
  const required = typeof codes === 'string' ? [codes] : codes;
  return async () => {
    const featureFlagStore = inject(FeatureFlagStore);
    const router = inject(Router);

    await featureFlagStore.load();

    return required.some(code => featureFlagStore.isEnabled(code))
      ? true
      : router.createUrlTree(['/calendar']);
  };
}
